import { useQuery } from '@tanstack/react-query';
import type AgentApiProvidedJobPostListsRecord from '@/types/serializers/AgentApiProvidedJobPostListsRecord';

export const PROVIDED_JOB_POST_LIST_SHOW_QUERY_KEY = '/agent/api/provided_job_post_lists/show';

export default function useProvidedJobPostListShow(id: string) {
  return useQuery({
    queryKey: [PROVIDED_JOB_POST_LIST_SHOW_QUERY_KEY, id],
    queryFn: async () => {
      const response = await fetch(`/agent/api/provided_job_post_lists/${id}.json`);
      if (!response.ok) throw new Error('Failed to fetch list');
      const data: AgentApiProvidedJobPostListsRecord = await response.json();
      return data;
    },
  });
}
